import React from 'react';

import {
  AppLayout,
} from 'AWS-UI-Components-React';

const Content = () => (
	<div className='awsui-grid awsui-util-p-s'>
    <div className='custom-home__header custom-awsui-util-pt-xxxl awsui-row'>
      <div className='col-xxs-12'>
        <div className='awsui-row'>
          <div className='custom-home__header-title col-xxs-10 offset-xxs-1 col-s-6 col-l-5 offset-l-2 col-xl-6'>
            <div className='awsui-text-large'>
              <div><h2>Welcome to the Home Page of Fraud Investigation Tools!</h2></div>
          	</div>
          	<div className='awsui-text-medium'>
          		<a href="/record">Record</a>
      		</div>
    	  </div>
      	</div>
      </div>
   	</div>
  	</div>
);

export class Welcome extends React.Component {

  render() {
    return (
      <div className="awsui">
        <AppLayout
                  className='awsui-util-no-gutters'
                  content={<Content/>}
                  navigationHide={true}
                  toolsHide={true}
                />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/welcome.jsx